import Logo from '@/components/Logo.vue'

export default
{
    components:
    {
        Logo
    },

    computed:
    {
        isServicePage()
        {
            return this.$route.name === 'mining'
                || this.$route.name === 'automation'
                || this.$route.name === 'ia'
        }
    }
}
